import gql from 'graphql-tag';

export const CountryFragments = {
  id: gql`
    fragment CountryId on Country {
      id
    }
  `,
};
